import { ReactNode } from 'react';
import { PaymentMethod } from '@mews-commander/data-access';
import { Link } from '@optimus-web/core';
import { DataTestId } from '@mews-commander/enums';
import { usePaymentsTablesContext } from '../PaymentsTablesContext';

interface Props {
    paymentMethodId: string;
    paymentMethod: PaymentMethod;
    sidebarTitle: ReactNode;
    linkTitle: ReactNode;
}

export const PaymentMethodSidebarLink = ({ paymentMethodId, paymentMethod, sidebarTitle, linkTitle }: Props) => {
    const { openPaymentMethodDetails } = usePaymentsTablesContext();
    return (
        <Link
            inherit
            onClick={() => openPaymentMethodDetails({ paymentMethodId, paymentMethod, sidebarTitle })}
            data-test-id={DataTestId.PaymentMethodLink}
        >
            {linkTitle}
        </Link>
    );
};
